import React, { useEffect } from 'react';
import styles from './ActionButton.module.css';
import { ReactSVG } from 'react-svg';
import { Icons, TerminalsIcon } from '@/assets';
import CloseButton from '@/ctComponents/closeButton';
import SubmitButton from '@/ctComponents/submitButton';
import { useTimeAgoWithUpdates } from '@/ctUtlis/timeAgoWithUpdates';
import { enableAutoBookScroll } from '@/utils/autobook-scroll';
import { removeNoScroll } from '@/actions/Helper';
import { CustomCircularProgress } from '@/components/Loading/CustomCircularProgress';

export default function ActionButton({
  setDisplay,
  data,
  shift,
  terminal,
  setShow,
  selectedData,
  setSelectedData,
  edit,
  appset,
  date,
  lastUpdate,
  status,
}) {
  let dateChanged = false;

  // Use the new time update hook
  const timeDisplay = useTimeAgoWithUpdates(lastUpdate);

  useEffect(() => {
    appset ? setSelectedData(appset) : setSelectedData(null);
  }, [appset]);
  return (
    <div className={styles.card}>
      <div
        style={{ justifyContent: !data.length > 0 && 'center' }}
        className={styles.cardContent}>
        {!data.length > 0 ? (
          <CustomCircularProgress />
        ) : (
          <>
            <div>
              <div className={styles.header}>
                <div className={styles.status}>
                  <ReactSVG
                    src={Icons.calendarday}
                    className={styles.icon}
                    beforeInjection={(svg) => {
                      svg.querySelectorAll('path').forEach((path) => {
                        path.setAttribute('stroke', ' #1FC16B');
                      });
                    }}
                  />
                  <span>Open for Receiving</span>
                </div>
                <span className={styles.subtext}>
                  Available appointment times last checked{' '}
                  <strong>{timeDisplay}</strong>
                </span>
              </div>
              <div className={styles.content}>
                <div className={styles.logoSection}>
                  <a className={styles.terminalLink} target="_blank">
                    <img
                      width={100}
                      src={TerminalsIcon[terminal?.replace(/\s+/g, '')]}
                    />
                  </a>
                  <div className={styles.verticalDashed} />
                </div>
                <div className={styles.details}>
                  <div className={styles.detailItem}>
                    <ReactSVG src={Icons.calendarday} className={styles.icon} />
                    Date:{' '}
                    <span className={styles.boldText}>
                      {date?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1')}
                    </span>
                  </div>
                  <div className={styles.detailItem}>
                    <ReactSVG src={Icons.clocktime} className={styles.icon} />
                    Shift:{' '}
                    <span className={styles.boldText}>
                      {shift === 1 ? '1st' : '2nd'}
                    </span>
                  </div>
                </div>
              </div>

              <table className={styles.table}>
                <thead>
                  <tr>
                    <th className={styles.th}>
                      <div className={styles.tableHeaderfirst}>
                        <ReactSVG
                          src={Icons.calendartime}
                          className={styles.icon}
                        />
                        Available Time
                      </div>
                    </th>
                    <th className={styles.th}>
                      <div className={styles.tableHeader}>
                        <ReactSVG
                          src={Icons.SingleShift}
                          className={styles.icon}
                        />
                        Single
                      </div>
                    </th>
                    <th className={styles.th}>
                      <div className={styles.tableHeader}>
                        <ReactSVG
                          src={Icons.DualShift}
                          className={styles.icon}
                        />
                        Dual
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className={styles.tableContainer}>
                  {data?.map((slot, index) => {
                    return (
                      <>
                        {date !== slot.date && !dateChanged && (
                          <tr key={index}>
                            {(dateChanged = true)}
                            <div className={styles.horizentalLineContainer}>
                              <span className="whitespace-nowrap">
                                {slot?.date?.replace(
                                  /(\d{4})-(\d{2})-(\d{2})/,
                                  '$2-$3-$1'
                                )}
                              </span>
                              <div className={styles.horizentalLine} />
                            </div>
                          </tr>
                        )}
                        <tr key={index}>
                          <td className={styles.td}>
                            <div className={styles.tableCell}>
                              {slot.time_start}
                              {' - '}
                              {slot.time_end}
                            </div>
                          </td>
                          <td
                            className={styles.td}
                            onClick={() =>
                              slot.id === selectedData
                                ? {}
                                : setSelectedData(slot.id)
                            }>
                            <div className={styles.tableCell}>
                              {slot.available_count > 0 ? (
                                <div
                                  className={styles.bookBtn}
                                  style={{
                                    backgroundColor:
                                      slot.id === selectedData
                                        ? '#335CFF'
                                        : 'transparent',
                                    color:
                                      slot.id === selectedData
                                        ? 'white'
                                        : '#335CFF',
                                    cursor:
                                      slot.id === selectedData
                                        ? 'default'
                                        : 'pointer',
                                  }}>
                                  Book ({slot.available_count} avail)
                                </div>
                              ) : (
                                <span className={styles.none}>None Avail</span>
                              )}
                            </div>
                          </td>
                          <td className={styles.td}>
                            <div className={styles.tableCell}>
                              <div className={styles.dropdown}>
                                <select
                                  className={styles.dropdowninside}
                                  disabled>
                                  <option>0 opportunity</option>
                                </select>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={styles.footer}>
              <span className={styles.link}>
                <ReactSVG
                  src={Icons.screenshoteye}
                  className={styles.screenshoteye}
                />
                View Screenshot
              </span>
              <div className={styles.buttonsContainer}>
                <CloseButton
                  onClick={() => {
                    setDisplay(false);
                    enableAutoBookScroll();
                    removeNoScroll();
                  }}
                  text={'Close'}
                />
                <SubmitButton
                  text={edit ? 'Reschedule Now' : 'Book Now'}
                  onClick={() => {
                    setShow(true);
                    setDisplay(false);
                    enableAutoBookScroll();
                  }}
                  disable={
                    !selectedData ||
                    selectedData === appset ||
                    status === 'RESERVATION_PENDING_APPROVAL' ||
                    status === 'CANCELLATION_PENDING_APPROVAL' ||
                    status === 'EDITING_PENDING_APPROVAL' ||
                    status === 'PENDING_RESERVE' ||
                    status === 'PENDING_CANCEL' ||
                    status === 'PENDING_EDIT' ||
                    status === 'USED'
                  }
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
